import 'whatwg-fetch';
import 'es6-promise';
import './utils/i18n';
import './utils/shim';
import './utils/Flags';
import './mossad/index.mossad.js';
import 'intersection-observer';
// import LoadFirst from './utils/loadFirst';
import Shim from 'fk-cp-shared/utils/shim'; // eslint-disable-line
import { Router, browserHistory } from 'react-router';
import React from 'react';
import { render } from 'react-dom';
import styles from './styles.css'; // eslint-disable-line
import { Provider } from 'react-redux';
import Logger from 'fk-cp-shared/utils/Logger';
// import RavenLogger from './utils/RavenLogger';
import Events from 'fk-cp-shared/utils/utils';
import clientStore from './clientStore';
import routes from './routes';
import './AppEnv';

import AppEnvironmentHelper from 'fk-cp-shared/utils/AppEnvironmentHelper.js';
import WebPerformanceTrackerFdp from '@flipkart/web-performance-tracker-fdp/webPerformanceTrackerFdp.js';
import FDPTrackers from '@utils/FDPHelperV2';
import NewRelicLogger from '@utils/newRelicLoghelper';
import CentralWebHeader from '@common/CentralWebHeader';

const events = new Events();
const name = 'fk-cp-selfserve';
const logger = new Logger();
const tracker = new WebPerformanceTrackerFdp();
const DEFAULT_LOCALE = 'en';
const newRelicLogger = new NewRelicLogger();

const metaInformation = {
	platform: AppEnvironmentHelper.getPlatformString(),
	pageUri: window.location.href,
	userAgent: window.navigator && window.navigator.userAgent,
	language: window.locale || DEFAULT_LOCALE,
	nm: 'self-serve-web-vitals'
};

const webVitalSuccessCallback = webVitals => {
	const customCurrentUrl = window.location.href;
	(webVitals.ev || []).forEach(metric => {
		if (metric.name && metric.value !== undefined) {
			newRelicLogger.logCustomEvent({
				type: `Custom_${metric.name}`,
				value: metric.value,
				customCurrentUrl,
				platform: AppEnvironmentHelper.getPlatformString()
			});
		}
	});
	FDPTrackers.trackEvent(webVitals);
};

const webVitalFailureCallback = error => {
	console.logError({
		type: 'WEB_VITAL_FAILURE',
		error: error
	});
};

if (tracker && tracker.initialise) {
	tracker.initialise(webVitalSuccessCallback, webVitalFailureCallback, metaInformation);
}
logger.start();

if (window.Android && window.Android.addElevation && typeof window.Android.addElevation === 'function') {
	window.Android.addElevation(0);
}

events.addEvent(window, 'DOMContentLoaded', () => {
	const container = document.createElement('div');
	container.id = name;
	document.body.appendChild(container);
	render(
		<Provider store={clientStore}>
			<React.Fragment>
				<CentralWebHeader />
				<Router onUpdate={() => window.scrollTo(0, 0)} routes={routes} history={browserHistory} />
			</React.Fragment>
		</Provider>,
		document.getElementById(name)
	);
});
